var path = 'areas/shared/views/user-name.html';
var html = "<span><span ng-show=isLoading.busy><em class=gray>loading...</em></span><span ng-show=\"displayName && !isLoading.busy\" title=\"{{ username }}\">{{ displayName }}</span><span ng-show=\"nullText && !displayName && !isLoading.busy\">{{ nullText }}</span></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/user-name.html
// module id = 831432551242613
// module chunks = 1